// src/components/search/SearchOptions.js
import React from 'react';
import Form from 'react-bootstrap/Form';
import { useDispatch, useSelector } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import {
  searchReferences,
  setSearchSizeResultsCount,
  setSearchResultsPage,
  setSortByPublishedDate,
} from '../../actions/searchActions';

import SearchPagination from './SearchPagination';
import SearchPreferencesControls from './settings/SearchPreferencesControls';

const SearchOptions = () => {
  const searchResultsCount = useSelector(
    (state) => state.search.searchResultsCount
  );
  const dispatch = useDispatch();

  return (
    <Container fluid>
      <Row className="align-items-center flex-wrap">
        {/* Results count */}
        <Col sm={2}>
          <div className="div-grey-border">
            {searchResultsCount > 0
              ? `${searchResultsCount.toLocaleString()} results`
              : null}
          </div>
        </Col>

        {/* Results per page */}
        <Col sm={2}>
          <Form.Control
            as="select"
            size="sm"
            defaultValue="50"
            onChange={(e) => {
              dispatch(setSearchSizeResultsCount(e.target.value));
              dispatch(setSearchResultsPage(1));
              dispatch(searchReferences());
            }}
          >
            <option value="10">Results per page 10</option>
            <option value="25">Results per page 25</option>
            <option value="50">Results per page 50</option>
            <option value="100">Results per page 100</option>
          </Form.Control>
        </Col>

        {/* Sort */}
        <Col sm={2}>
          <Form.Control
            as="select"
            size="sm"
            defaultValue="relevance"
            onChange={(e) => {
              dispatch(setSortByPublishedDate(e.target.value));
              dispatch(searchReferences());
            }}
          >
            <option value="relevance">Sort by relevance</option>
            <option value="desc">Newest first</option>
            <option value="asc">Oldest first</option>
          </Form.Control>
        </Col>

        {/* Right side: Preferences + Load setting + Pagination */}
        <Col sm={6}>
          <div className="d-flex align-items-center gap-2 flex-wrap">
            {/* Pagination */}
            <div style={{ marginTop: '16px' }}>
	      <SearchPagination />
	    </div>
	    {/* Preferences + Load setting */}
            <div style={{ marginLeft: '2em', marginTop: '8px' }}>
              <SearchPreferencesControls />
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default SearchOptions;
